var _defs, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternSmallCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 202,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D0202",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5D0202",
    stopOpacity: 0.498
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 101,
    r: 101,
    fill: "url(#a)",
    fillRule: "evenodd",
    opacity: 0.203,
    transform: "matrix(-1 0 0 1 202 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternSmallCircle);
export default __webpack_public_path__ + "static/media/bg-pattern-small-circle.6998c69d139ac33cf6f782c5f75cb64f.svg";
export { ForwardRef as ReactComponent };